export default __webpack_public_path__ + "static/media/banner5.06dc9534.jpg";